<template>
  <section class="audio-recoding">
    <div v-if="!openPreview">
      <div class="recoding-icon">
        <span class="recod-icon" :class="{'circle': isRecordingStarted}">
          <img src="@/assets/images/ic-mic.svg" alt />
        </span>
        <span class="back-btn" @click="goBack()">
          <img src="@/assets/images/arrow-w.svg" alt />
        </span>
      </div>
      <div class="bottom-block-btn">
        <div class="slide" :class="{'on':isRecordingStarted}">
          <img class="one" src="@/assets/images/big.svg" alt />
          <img class="two" src="@/assets/images/big.svg" alt />
        </div>
        <div class="btn-part">
          <span class="recoding-time" v-if="!isRecordingStarted">00:00:00</span>
          <span class="recoding-time" v-if="isRecordingStarted">00:00:00</span>
          <!-- <Timer :timing="getLiveTime(12300)" v-if="isRecordingStarted" /> -->
          <span class="recodin-btn">
            <span class="square" v-if="!isRecordingStarted" @click="startRecording()"></span>
            <span
              class="square"
              :class="{'on' :isRecordingStarted }"
              v-if="isRecordingStarted"
              @click="stopRecording()"
            ></span>
          </span>
        </div>
      </div>
    </div>

    <audio-preview :getAudioData="recordedAudio" :totalTime="secondsOnly" v-if="openPreview" />

    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
    <div class="loader" v-if="loading">
      <img src="@/assets/images/loader.gif" alt="loader" />
    </div>
  </section>
</template>

<script>
import ApiCaller from "@/utils/apicaller";
import constant from "@/utils/constant";
import { SessionHelper, X_AUTH_ID, JWT_TOKEN } from "@/utils/session";
import CustomToaster from "@/components/Common/CustomToaster";
import AudioPreview from "@/components/NewsModule/AudioPreview";
import axios from "axios";
import Timer from "@/components/Common/Timer";
// import { uploadImageFile } from "@/utils/helper";

export default {
  name: "AudioRecording",
  components: { AudioPreview, Timer },
  computed: {},
  data() {
    return {
      isValidDetail: false,
      toasterData: {},
      loading: false,
      isRecordingStarted: false,
      rec: null,
      audioChunks: [],
      recordedAudio: "",
      openPreview: false,
      totalTime: '',
      seconds : 0, minutes : 0, hours : 0,
      secondsOnly: 0
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    add() {
      console.log('===add====')
      this.seconds++;
      this.secondsOnly++
      if (this.seconds >= 60) {
          this.seconds = 0;
          this.minutes++;
          if (this.minutes >= 60) {
              this.minutes = 0;
              this.hours++;
          }
      }    
      document.getElementsByClassName('recoding-time')[0].innerHTML = (this.hours ? (this.hours > 9 ? this.hours : "0" + this.hours) : "00") + ":" + (this.minutes ? (this.minutes > 9 ? this.minutes : "0" + this.minutes) : "00") + ":" + (this.seconds > 9 ? this.seconds : "0" + this.seconds);
      this.timer();
    },
    timer() {
        this.totalTime = setTimeout(this.add, 1000);
    },
    clearTime(){
      document.getElementsByClassName('recoding-time')[0].innerHTML = "00:00:00";
      this.seconds = 0; this.minutes = 0; this.hours = 0;
    },
    goToPreview() {
      
      // this.$router.push(`/audio-preview?a=${this.totalTime}`);
    },
    startRecording() {
      this.isRecordingStarted = !this.isRecordingStarted;
      this.timer()
      this.audioChunks = [];
      this.rec.start();
    },
    stopRecording() {
      this.isRecordingStarted = !this.isRecordingStarted;
      clearTimeout(this.totalTime);
      var hms = document.getElementsByClassName('recoding-time')[0].innerHTML;   // your input string
      // var a = hms.split(':'); // split it at the colons

      // minutes are worth 60 seconds. Hours are worth 60 minutes.
      var seconds = new Date('1970-01-01T' + document.getElementsByClassName('recoding-time')[0].innerHTML + 'Z').getTime() / 1000;       
      this.rec.stop();
      
    },
    async start() {
      navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
        this.handlerFunction(stream);
      });
    },
    handlerFunction(stream) {
      this.rec = new MediaRecorder(stream);
      this.rec.ondataavailable = e => {
        this.audioChunks.push(e.data);
        if (this.rec.state == "inactive") {
        let blob = new Blob(this.audioChunks, { type: "audio/mpeg" });
        // this.recordedAudio = URL.createObjectURL(blob);
        this.uploadImageFile(blob)
        }
      };
    },
    async uploadImageFile(file) {
        await axios.put(constant.FILE_UPLOAD_URL +'binary?fileType=mp3', file, {
          headers: {
            "Content-Type": "application/octet-stream",
            "X-Auth-Id" : SessionHelper.getCookie(X_AUTH_ID),
            "JWT-TOKEN": SessionHelper.getCookie(JWT_TOKEN)
          }
        })
        .then(data => {
          this.loading = false;
          this.recordedAudio = data.data.Data.CdnUrl
          if(this.recordedAudio){
            this.openPreview = true
          }

        })
        .catch(err => {
          this.loading = false;
          console.log("FAILURE", err);
        });
    },
    // sendAudioFile(file) {
    //   var reader = new FileReader();
    //     reader.readAsDataURL(file);
    //     reader.onloadend = function () {
    //     var base64String = reader.result;
    //     console.log('Base64 String - ', base64String);
    //     }
    // },
   
  },
  mounted() {
    console.log(document.getElementsByClassName('recoding-time')[0].innerHTML)
    __native_money91.checkForPermissionResult = result => {
      if (result.length) {
        alert("Please Allow audio permission");
        JSBridgePlugin.gotToHome();
      } else {
        this.start();
      }
    };
    const _ = ["android.permission.RECORD_AUDIO"];
    try {
      JSBridgePlugin.checkForPermission(
        _,
        true,
        "__native_money91.checkForPermissionResult"
      );
    } catch (err) {
      console.log(err);
      this.start();
    }
  }
};
   
</script>

